import { createFileRoute } from "@tanstack/react-router";
import { Spinner } from "@heroui/react";

import { AppVersionsForm } from "@/features/app-versions/ui/app-versions-form.tsx";
import { useAppVersions } from "@/features/app-versions/use-app-versions.ts";
import { PageLayout } from "@/shared/components/page-layout.ui.tsx";

export const Route = createFileRoute("/dashboard/app-versions")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isLoading } = useAppVersions();

  return (
    <PageLayout title="Версии приложений">
      <p className="px-4 pb-2 text-sm text-default-500">
        Приложение запрашивает эти настройки при запуске: показывает шторку
        обновления и заглушку техработ. Изменения действуют сразу, без
        перезапуска сервисов.
      </p>

      {isLoading || !data ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <AppVersionsForm versions={data.data} />
      )}
    </PageLayout>
  );
}
